import * as React from 'react';

import { ToggleButtonBar } from './parts/ToggleButtonBar';

interface IToggleButtonProps {
  closedText: string;
  opened: boolean;
  onClick(): void;
}

export function ToggleButton({ closedText, opened, onClick }: IToggleButtonProps) {
  return (
    <ToggleButtonBar isOpened={opened} onClick={onClick}>
      {opened ? 'Свернуть' : closedText}
    </ToggleButtonBar>
  );
}
